import { render, staticRenderFns } from "./SpinnerWheelCanvas.vue?vue&type=template&id=41848784&scoped=true"
import script from "./SpinnerWheelCanvas.vue?vue&type=script&lang=js"
export * from "./SpinnerWheelCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41848784",
  null
  
)

export default component.exports